var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIconOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.5C11.2044 5.5 10.4413 5.81607 9.87868 6.37868C9.31607 6.94129 9 7.70435 9 8.5C9 9.29565 9.31607 10.0587 9.87868 10.6213C10.4413 11.1839 11.2044 11.5 12 11.5C12.7956 11.5 13.5587 11.1839 14.1213 10.6213C14.6839 10.0587 15 9.29565 15 8.5C15 7.70435 14.6839 6.94129 14.1213 6.37868C13.5587 5.81607 12.7956 5.5 12 5.5ZM12 13.5C10.6739 13.5 9.40215 12.9732 8.46447 12.0355C7.52678 11.0979 7 9.82608 7 8.5C7 7.17392 7.52678 5.90215 8.46447 4.96447C9.40215 4.02678 10.6739 3.5 12 3.5C13.3261 3.5 14.5979 4.02678 15.5355 4.96447C16.4732 5.90215 17 7.17392 17 8.5C17 9.82608 16.4732 11.0979 15.5355 12.0355C14.5979 12.9732 13.3261 13.5 12 13.5ZM12 1C7 1 2.73 4.11 1 8.5C2.73 12.89 7 16 12 16C17 16 21.27 12.89 23 8.5C21.27 4.11 17 1 12 1Z",
    fill: "#4B4A5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1L23 16",
    stroke: "#4B4A5B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIconOff);
export default __webpack_public_path__ + "static/media/eye-icon-off.0c555743ed80b292c647ae5ba76e1d82.svg";
export { ForwardRef as ReactComponent };